import { Box, BoxProps, ImageProps, Spacer, Text } from '@jfs/ui-new'
import MobileWebColor from '../../assets/svg/MobileWebColor'
import { staticStrings } from '../../static/staticStrings'
import useFontSize from '../../util/useFontSize'

export const GoAbove = ({ isMob }: any) => {
  const { textSize, headerSize } = useFontSize()

  const styles = style(isMob)
  return (
    <Box {...styles.mainContainer}>
      <Box {...styles.leftContainer}>
        <Box {...styles.leftBox}>
          <Text title={'Go above and beyond'} fontFamily={'jiotype-black'} fontSize={headerSize} color={'BLACK_21'} />
          <Spacer size={16} />
          <Box paddingRight={isMob ? 0 : 80}>
            <Text
              title={staticStrings.goBeyondSubTItle}
              fontFamily={'jiotype-medium'}
              fontSize={textSize}
              color={'BLACK_21'}
              opacity={0.9}
              lineHeight={isMob ? 20 : 32}
            />
          </Box>
        </Box>
      </Box>
      <Box {...styles.rightContainer}>
        <MobileWebColor {...styles.imageBox} />
      </Box>
    </Box>
  )
}

const style = (isMob: boolean) => {
  return {
    mainContainer: {
      justify: 'space-between',
      flexDirection: isMob ? 'column-reverse' : 'row-reverse',
      pv: 80,
    } as BoxProps,
    leftContainer: {
      f: isMob ? undefined : 0.5,
    } as BoxProps,
    rightContainer: {
      f: isMob ? undefined : 0.5,
    } as BoxProps,
    leftBox: {
      f: isMob ? undefined : 1,
      justifyContent: 'center',
      pt: isMob ? 12 : undefined,
    } as BoxProps,
    imageBox: {
      width: isMob ? '100%' : 460,
      height: isMob ? 240 : 300,
      resizeMode: 'center',
    } as ImageProps,
  }
}
